import { SearchOffers } from '@lambda/commons/apis/elasticsearch/types';
import { useEffect, useState } from 'react';
import cn from 'classnames';
import Loading from '@/components/Loading/Loading';
import { breakpoints } from './constants';
import Section from '@/components/commons/Section';
import Slider from '@/components/slider/Slider';
import ProductCard from '@/components/category/ProductCard';
import { BestSellersProps } from './types';

const BestSellers = ({
  categories,
  className,
  isThankYouPage,
  title = 'Best Sellers',
}: BestSellersProps) => {
  const [offers, setOffers] = useState<SearchOffers[] | null>(null);

  useEffect(() => {
    const fetchPopularItems = async () => {
      try {
        const response = await fetch('/api/cart/best-seller-offers', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ categories }),
        });

        if (!response.ok) throw new Error(`Error: ${response.statusText}`);

        const data: SearchOffers[] = await response.json();

        setOffers(data);
      } catch (err: any) {
        setOffers([]);
      }
    };

    fetchPopularItems();
  }, []);

  if ((offers != null && offers.length === 0) || categories.length === 0)
    return null;

  return (
    <Section className={className}>
      <h2
        className={cn('font-bold', {
          'text-lg md:text-xl': isThankYouPage,
          'text-base': !isThankYouPage,
        })}
      >
        {title}
      </h2>
      {offers != null ? (
        <div className="relative mt-3">
          <Slider breakpoints={breakpoints}>
            {offers.map((offer) => (
              <ProductCard key={offer.key} offer={offer} size="sm" />
            ))}
          </Slider>
        </div>
      ) : (
        <Loading />
      )}
    </Section>
  );
};

export default BestSellers;
